import {Map as MapApi, MapboxOptions, Marker, NavigationControl} from "maplibre-gl"

import {LanguageControl} from "./LanguageControl"
import {InfoboxControl, InfoboxOptions} from "./InfoboxControl"

import "maplibre-gl/dist/maplibre-gl.css";
import {CooperativeGestureControl} from "./CooperativeGestureControl";

export type Options = {
    showMarker?: boolean;
    markerColor?: string;

    showNavigationControls?: boolean;

    showInfobox?: boolean;
    infoboxOptions?: InfoboxOptions;

    disableScrollZoom?: boolean,
    disableRotation?: boolean;

    cooperativeGestures?: boolean;
}

const defaultOptions = {
    showMarker: true,
    markerColor: '#A60A2D',

    showNavigationControls: true,

    showInfobox: false,

    disableScrollZoom: true,
    disableRotation: true,

    cooperativeGestures: true,
}

export function Map(mapOptions: MapboxOptions, options: Options = {}): MapApi {
    mapOptions = Object.assign({}, mapOptions, {
        maxZoom: 17,
        maxBounds: [
            [-34.49296, 29.63555],
            [46.75348, 81.47299],
        ],
    })
    options = Object.assign({}, defaultOptions, options)

    const map = new MapApi(mapOptions);

    // Auto-choose translation based on browser language
    map.addControl(new LanguageControl({
        supportedLanguages: ['de', 'en', 'fr', 'dk', 'es', 'pl', 'it'],
    }))

    if (options.showNavigationControls) {
        // Add zoom controls
        map.addControl(new NavigationControl({showCompass: false}), 'bottom-right')
    }

    if (options.showInfobox) {
        const infobox = new InfoboxControl(options.infoboxOptions)
        if (infobox.canShow()) {
            map.addControl(infobox)
        }
    }

    if (options.showMarker) {
        // Add marker
        new Marker({color: options.markerColor}).setLngLat([map.getCenter().lng, map.getCenter().lat]).addTo(map)
    }

    if (options.disableScrollZoom) {
        map.scrollZoom.disable()
    }

    if (options.disableRotation) {
        map.dragRotate.disable()
        map.touchZoomRotate.disableRotation()
    }

    if (options.cooperativeGestures) {
        map.addControl(new CooperativeGestureControl())
    }

    return map;
}
